import { Navigate, Route, Routes } from "react-router-dom";
import { lazy } from "react";
import withFeatureRestriction from "../utils/withFeatureRestriction.js";

const DoctorDashboard = lazy(() => import("../screens/DoctorRole/Dashboard"));
const DoctorAppointments = lazy(() =>
  import("../screens/DoctorRole/Appointments.js")
);
const DoctorPatients = lazy(() => import("../screens/DoctorRole/Patients.js"));
const DoctorSettings = lazy(() => import("../screens/DoctorRole/Settings.js"));
const PatientProfileDoc = lazy(() =>
  import("../screens/Patients/PatientProfileDoc")
);
const CreatePreventiv = lazy(() =>
  import("../screens/Invoices/CreatePreventiv")
);
const NewMedicalRecord = lazy(() => import("../screens/NewMedicalRecord"));
const Services = lazy(() => import("../screens/Services"));

const WithFeatureCreatePreventiv = withFeatureRestriction(
  CreatePreventiv,
  "invoices"
);

export default function DoctorRoutes() {
  return (
    <Routes>
      <Route path="/" element={<DoctorDashboard />} />
      <Route path="patients" element={<DoctorPatients />} />
      <Route path="patients/:id" element={<PatientProfileDoc />} />
      <Route path="patients/visiting/:id" element={<NewMedicalRecord />} />
      <Route path="services" element={<Services />} />
      <Route path="appointments" element={<DoctorAppointments />} />
      <Route path="settings" element={<DoctorSettings />} />

      {/* WITH FEATURE RESTRICTION */}
      <Route
        path="invoices/preventiv/create"
        element={<WithFeatureCreatePreventiv />}
      />

      <Route path="*" element={<Navigate to="/doctor" replace />} />
    </Routes>
  );
}
